import { render, staticRenderFns } from "./App.vue?vue&type=template&id=b2bf8b30&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=b2bf8b30&prod&lang=css&"
import style1 from "./App.vue?vue&type=style&index=1&id=b2bf8b30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports